/**
 * Navegación de semanas del horario (presentacional).
 *
 * Réplica de la barra "Semana Anterior / rango / Semana Siguiente" del SSR
 * (`schedule.html`). En el SSR cada flecha era un enlace a `?week=offset±1`; aquí el
 * desplazamiento es estado de la pantalla y las flechas lo cambian (la query key del
 * horario incluye el offset, así que al cambiarlo se pide la semana nueva). Sin
 * lógica de datos: recibe el rango ya formateado y notifica el cambio al padre.
 */
import { Button } from "@/components/ui";

interface WeekNavigatorProps {
  /** Rango de la semana ya formateado (p. ej. "09/06 - 15/06/2026"). */
  rangeLabel: string;
  onPrev: () => void;
  onNext: () => void;
}

export function WeekNavigator({ rangeLabel, onPrev, onNext }: WeekNavigatorProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white p-3">
      <Button type="button" variant="secondary" size="sm" onClick={onPrev}>
        ← Semana anterior
      </Button>
      <span className="text-sm font-semibold text-slate-700">
        {rangeLabel || "—"}
      </span>
      <Button type="button" variant="secondary" size="sm" onClick={onNext}>
        Semana siguiente →
      </Button>
    </div>
  );
}
